import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCalendarRoute: InvariantJiraRoute = {
	name: 'servicedesk-calendar',
	path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
	exact: true,
};
